import { useTranslations } from '@vocab/react';
import { Stack, Box, Heading } from 'braid-design-system';

import ThreadCard from 'src/components/molecules/Shared/ThreadCard/ThreadCard';
import { useAnalytics } from 'src/provider/analytics';
import { useThreads } from 'src/provider/threads';

import translations from './.vocab';

export default () => {
  const { t } = useTranslations(translations);
  const { trackAnalyticsInteraction } = useAnalytics();

  const {
    threadsState: { displayThreads },
    threadsDispatch,
  } = useThreads();

  const handleLikeSuccess = (
    id: string,
    countLabel: string,
    isLiked: boolean,
  ) => {
    try {
      threadsDispatch({
        type: 'UPDATE_THREAD_LIKE_IN_FEED',
        payload: { id, likeCountLabel: countLabel, liked: isLiked },
      });
      if (id) {
        trackAnalyticsInteraction('LikeThreadClick', {
          threadId: id,
          linkAction: !isLiked ? 'like' : 'unlike',
          linkPosition: 'thread',
        });
      }
    } catch {
      // ignore
    }
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box paddingBottom="large" paddingRight="small" paddingTop="medium">
        <Heading level="3" weight="regular">
          {t('featuredThreads')}
        </Heading>
      </Box>
      <Stack space="small">
        {displayThreads.map((thread) => (
          <ThreadCard
            key={thread.id}
            thread={thread}
            isFeatured={true}
            onLikeSuccess={handleLikeSuccess}
          />
        ))}
      </Stack>
    </Box>
  );
};
